import { render, staticRenderFns } from "./Coordinator.vue?vue&type=template&id=1d09748c&scoped=true&"
import script from "./Coordinator.vue?vue&type=script&lang=js&"
export * from "./Coordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d09748c",
  null
  
)

export default component.exports